import { render, staticRenderFns } from "./EditBalletClass.vue?vue&type=template&id=faa07e3c"
import script from "./EditBalletClass.vue?vue&type=script&lang=js"
export * from "./EditBalletClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports